import CrudCustom from '../../../libs/custom/CrudCustom';

let PeriodePphUnifikasiService = new CrudCustom('/periode-pph-unifikasis');
export default PeriodePphUnifikasiService;
